import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addPopup } from '../../../../../redux/actions';
import { getMediaPath } from '../../../../../app/functions';
import AnalyticsManager from '../../../../../app/analytics';
import { AnalyticsParamValues } from '../../../../../constants/analytics';
import * as popups from '../../../../../constants/popup-types';
import * as routes from '../../../../../constants/routes';
import playIcon from '../../../../../assets/magazine/icons/icons-small-play.svg';
import './index.scss';

const VideoBanner = ({ data }) => {
    const dispatch = useDispatch();

    const translations = useSelector((store) => store.config.Translations);
    const magazineCategories = useSelector((store) => store.data.magazineCategories);
    const deviceState = useSelector((store) => store.state.deviceState);

    const isMobile = (deviceState === 'mobile');

    const videoId = data['article_id'];
    const videoData = data['article_data'];
    const videoType = Number(data['video_banner_type']);

    const normalThumbnail = videoData['thumbnail_path']
        ? getMediaPath(videoData['thumbnail_path'])
        : videoData['thumbnail_url'];

    const mobileThumbnail = videoData['mobile_thumbnail_path']
        ? getMediaPath(videoData['mobile_thumbnail_path'])
        : videoData['thumbnail_url'];

    let relatedMagazineData = magazineCategories.find(
        (categoryData) => categoryData['id'] === videoData['related_magazine']
    );

    // In case of a video article without text, or if no related magazine found - use the video magazine by default
    if (videoType === 0 || !relatedMagazineData) {
        relatedMagazineData = {
            title: translations['magazine_video_category'],
        };
    }

    const buttonLink = `${routes.magazine}/${relatedMagazineData['title']}` + (
        videoType === 1 ? `/${videoId}` : ''
    );

    const buttonText = videoType === 1
        ? translations['homepage_slider_specific_article_link']
        : translations['homepage_slider_all_video_articles_link'];

    // Open a video-article popup on thumbnail click
    const handleThumbnailClick = () => {
        AnalyticsManager.logHomepageTopSliderPress(data?.['id'], data?.['title']);

        AnalyticsManager.logVideoArticlePress(
            data?.['article_id'], null, AnalyticsParamValues.HOMEPAGE_TOP_SLIDER_SOURCE
        );

        dispatch(addPopup({
            type: popups.VIDEO_ARTICLE,
            article: {
                id: data['article_id'],
                ...videoData,
            },
            shouldRedirect: false,
            buttonText,
            buttonLink,
        }));
    };

    return (
        <div className="top-slider-video-banner">
            <div onClick={handleThumbnailClick} className="thumbnail-container">
                <img
                    src={isMobile ? mobileThumbnail : normalThumbnail}
                    alt={videoData['title']}
                    className="thumbnail-image"
                />

                <img src={playIcon} alt="Play Icon" className="thumbnail-play-icon" />
            </div>

            <div className="info-container">
                <div>
                    <p className="video-title">
                        {videoData['title']}
                    </p>

                    {videoData['sub_title'] && (
                        <p className="video-subtitle">
                            {videoData['sub_title']}
                        </p>
                    )}
                </div>

                <a href={buttonLink} className="video-link">
                    {buttonText}
                </a>
            </div>
        </div>
    );
};

export default VideoBanner;
